import * as React from "react";

function SvgTelegram(props) {
  return <svg className="telegram_svg__icon" viewBox="0 0 1024 1024" width="1em" height="1em" {...props}><defs><style /></defs><path d="M512 16C238 16 16 238 16 512s222 496 496 496 496-222 496-496S786 16 512 16zm243.6 339.8l-81.4 383.6c-6 27.2-22.2 33.8-44.8 21l-124-91.4-59.8 57.6c-6.6 6.6-12.2 12.2-25 12.2l8.8-126.2L659.2 405c10-8.8-2.2-13.8-15.4-5l-284 178.8-122.4-38.2c-26.6-8.4-27.2-26.6 5.6-39.4l478.2-184.4c22.2-8 41.6 5.4 34.4 39z" fill="#1296db" /></svg>;
}

export default __webpack_public_path__ + "media/icons/telegram-5dbf9a2714c15975794d28b70e74a00c.svg";
export { SvgTelegram as ReactComponent };